import { keccak256, solidityPackedKeccak256, getAddress  } from "ethers";
// Popup manager import removed as non-ETH branches were pruned
//import { popupManager } from '../components/common/PopupManager';
//const bs58 = require("bs58").default;

const { ethers,Contract,parseUnits  } = require("ethers");
const ERC20 = require("./swapping/build/ERC20.json");

const PAIR = require("./swapping/build/IUniswapV2Pair.json"); 
const ROUTER = require("./swapping/build/UniswapV2Router02.json"); 
const HARDSTAKE = require("./swapping/build/hardstake.json");
const HARDLOCK = require("./swapping/build/hardlock.json");
const HARDLOCK_VISTA = require("./swapping/build/hardlock_vista.json")
const FACTORY = require("./swapping/build/IUniswapV2Factory.json");
/* global BigInt */

// Solana ABIs removed

const ethprovider = new ethers.JsonRpcProvider(
  "https://ethereum-mainnet.core.chainstack.com/7cb41e194623a44e5dfa5b00dff031ad/"
); //We will use our own RPC
const EthFactoryAddress = "0x9a27cb5ae0B2cEe0bb71f9A85C0D60f3920757B4"; 
const EthRouterSwap = new ethers.Contract("0xCEDd366065A146a039B92Db35756ecD7688FCC77",ROUTER.abi, ethprovider)
const EthcontractUni = new ethers.Contract(EthFactoryAddress, FACTORY.abi, ethprovider);
const initHashEth = "0xe260b72768e8ec6814aa811c576f346d208ba00840f835949d65c6424ac80a8d";
const ethWeth = "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2";

// Non-ETH chain providers/contracts removed

// Solana support removed

export async function getDecimals(token) {
    const decimals = await token
      .decimals()
      .then((result) => {
        return result;
      })
      .catch((error) => {
        return 18;
      });
    return decimals;
}
export async function getBalanceAndSymbol(
    address,
    weth_address,
    signer,
    hardlock = false
  ) {
    const accountAddress = await signer.getAddress();
    const network = await signer.provider.getNetwork();
    //console.log(network)
    const chainId = Number(network.chainId);
    let providerChain;
    if (chainId === 1){
      providerChain = ethprovider
    } else { return }

    try {
      if (address === weth_address) {
        const balanceRaw = await providerChain.getBalance(accountAddress.toString());
        return ethers.formatEther(balanceRaw)
      } else {
        const token = new Contract(address, ERC20.abi, providerChain);
        const decimals = await getDecimals(token)
        const balanceRaw = await token.balanceOf(accountAddress.toString());
        const balanceFormatted = ethers.formatUnits(balanceRaw, decimals);
        return balanceFormatted
      }
    } catch (error) {
      console.log(error);
      return false;
    }
}

//internal function
export async function fetchReserves(address1, address2, pair, signer) {
    try {
      const coin1 = new Contract(address1, ERC20.abi, signer.provider);
      const coin2 = new Contract(address2, ERC20.abi, signer.provider);
      const coin1Decimals = await getDecimals(coin1);
      const coin2Decimals = await getDecimals(coin2);

      // Get reserves
      const reservesRaw = await pair.getReserves();
  
      // Put the results in the right order
      const results = [
        (await pair.token0()) === address1 ? reservesRaw[0] : reservesRaw[1],
        (await pair.token1()) === address2 ? reservesRaw[1] : reservesRaw[0],
      ];
  
      // Scale each to the right decimal place
      const formattedReserve0 = ethers.formatUnits(results[0], coin1Decimals);
      const formattedReserve1 = ethers.formatUnits(results[1], coin2Decimals);
      
      return [formattedReserve0, formattedReserve1];
    } catch (err) {
      //console.log("error!");
      //console.log(err);
      return [0, 0];
    }
}

export async function getReserves(
    address1,
    address2,
    signer,
    chain
  ) {

    let contractChain = EthcontractUni;
    let accountAddress = await signer.getAddress();
    try {
      const pairAddress = await contractChain.getPair(address1, address2);
      const pair = new Contract(pairAddress, PAIR.abi, signer.provider);
      if (pairAddress !== "0x0000000000000000000000000000000000000000") {
        const reservesRaw = await fetchReserves(address1, address2, pair, signer.provider);
        const liquidityTokens_BN = await pair.balanceOf(accountAddress);
        const liquidityTokens = Number(
          ethers.formatEther(liquidityTokens_BN)
        );
        return [
          Number(reservesRaw[0]).toPrecision(6),
          Number(reservesRaw[1]).toPrecision(6),
          liquidityTokens,
        ];
      } else {
        return [0, 0, 0];
      }
    } catch (err) {
      console.log("error!");
      console.log(err);
      return [0, 0, 0];
    }
}

export const quote = (amount1, reserve1, reserve2) => {

    const amount2 = amount1 * (reserve2 / reserve1);
    return [amount2];
};
export async function quoteMintLiquidity(
    address1,
    address2,
    amountA,
    amountB,
    signer,
    chain
  ) {
try{
    let RouterChain = EthRouterSwap
    let contractChain = EthcontractUni
    const MINIMUM_LIQUIDITY = 1000;
    let _reserveA = 0;
    let _reserveB = 0;
    let totalSupply = 0;
    let pair;
    [_reserveA, _reserveB, totalSupply] = await contractChain
      .getPair(address1, address2)
      .then(async (pairAddress) => {
        if (pairAddress !== "0x0000000000000000000000000000000000000000") {
            pair = new Contract(pairAddress, PAIR.abi, signer.provider);
  
          const reservesRaw = await fetchReserves(
            address1,
            address2,
            pair,
            signer.provider
          ); 
          const reserveA = reservesRaw[0];
          const reserveB = reservesRaw[1];
  
          const _totalSupply = await pair.totalSupply();
          const totalSupply = Number(ethers.formatEther(_totalSupply));
          return [reserveA, reserveB, totalSupply];
        } else {
            return [0, 0, 0];
        }
      });
  
    const token1 = new Contract(address1, ERC20.abi, signer.provider);
    const token2 = new Contract(address2, ERC20.abi, signer.provider);
    
    const token1Decimals = await getDecimals(token1);
    const token2Decimals = await getDecimals(token2);

    const valueA = BigInt(amountA*token1Decimals); //assume both tokens have 18 decimals 
    const valueB = BigInt(amountB*token2Decimals);
    
    const reserveA = BigInt(_reserveA*token1Decimals);
    const reserveB = BigInt(_reserveB*token2Decimals);
    
  
    if (totalSupply == 0) {
      return Math.sqrt(valueA * valueB - MINIMUM_LIQUIDITY) * 10 ** -18;
    }

    return Math.min(
      (Number(valueA) * totalSupply) / Number(reserveA),
      (Number(valueB) * totalSupply) / Number(reserveB)
    );
  }catch(e){
    console.log(e)
  }
}  
export async function deployLiquidity(
  address1,
  address2,
  amount1,
  amount2,
  amount1min,
  amount2min,
  signer,
  ethAdress,
  chain
) {
  const network = await signer.provider.getNetwork();
  const chainId = Number(network.chainId);
  let RouterSwap = EthRouterSwap.connect(signer);
  if(chainId !== 1){
    throw Error("Please Switch to ETH chain")
    return;
  }

  let account = await signer.getAddress();
  let routerAddress = await RouterSwap.getAddress();
  let token1;
  let token2;
  token1 = new Contract(address1, ERC20.abi, signer);
  token2 = new Contract(address2, ERC20.abi, signer);

  const token1Decimals = await getDecimals(token1);
  const token2Decimals = await getDecimals(token2);

  const amountIn1 = ethers.parseUnits(amount1, token1Decimals);
  const amountIn2 = ethers.parseUnits(amount2, token2Decimals);

  const amount1Min = ethers.parseUnits(amount1min, token1Decimals);
  const amount2Min = ethers.parseUnits(amount2min, token2Decimals);

  const time = Math.floor(Date.now() / 1000) + 200000;
  const deadline = BigInt(time);

  if (address1 === ethAdress) {
    const allowance2 = await token2.allowance(account, routerAddress );
    if (allowance2 < amountIn2) {
      // Dynamically estimate the required gas limit 
      let tx = await token2.approve(
        routerAddress ,
        ethers.MaxUint256,
        { gasLimit: 200000 } // Add a buffer to the estimated gas
      );
      await tx.wait();
    }
    await RouterSwap.addLiquidityETH(
      address2,
      BigInt(amountIn2),
      BigInt(amount2Min),
      BigInt(amount1Min),
      deadline,
      { value: BigInt(amountIn1) }
    );
  }
}

export async function quoteRemoveLiquidity(
  address1,
  address2,
  liquidity,
  signer,
  chain
) {
  let contractChain = EthcontractUni;
  const pairAddress = await contractChain.getPair(address1, address2);
  const pair = new Contract(pairAddress, PAIR.abi, signer.provider);

  const reservesRaw = await fetchReserves(address1, address2, pair, signer.provider); // Returns the reserves already formated as ethers
  const reserveA = reservesRaw[0];
  const reserveB = reservesRaw[1];

  const _totalSupply = await pair.totalSupply();
  let totalSupply = Number(ethers.formatEther(_totalSupply));

  const Aout = (reserveA * liquidity) / totalSupply;
  const Bout = (reserveB * liquidity) / totalSupply;

  return [liquidity, Aout, Bout];
}
export async function removeLiquidity(
  address1,
  address2,
  liquidity_tokens,
  amount1min,
  amount2min,
  signer,
  ethAddress,
  chain
) {
  let RouterChain = EthRouterSwap.connect(signer);
  let contractChain = EthcontractUni;

  let account = await signer.getAddress();
  let routerAddress = await RouterChain.getAddress();
  let token1;
  let token2;
  token1 = new Contract(address1, ERC20.abi, signer);
  token2 = new Contract(address2, ERC20.abi, signer);
  const token1Decimals = await getDecimals(token1);
  const token2Decimals = await getDecimals(token2);

  const Getliquidity = (liquidity_tokens) => {
    if (liquidity_tokens < 0.001) {
      return BigInt(liquidity_tokens * 10 ** 18);
    }
    return ethers.parseUnits(String(liquidity_tokens), 18);
  };

  const liquidity = Getliquidity(liquidity_tokens);

  const amount1Min = ethers.parseUnits(
    String(amount1min),
    token1Decimals
  );
  const amount2Min = ethers.parseUnits(
    String(amount2min),
    token2Decimals
  );

  const time = Math.floor(Date.now() / 1000) + 200000;
  const deadline =BigInt(time);

  const pairAddress = await contractChain.getPair(address1, address2);
  let pair;
  pair = new Contract(pairAddress, PAIR.abi, signer);

  const allowance = await pair.allowance(account, routerAddress);

  /* Example use case removed (Solana/Neon) */

  
  if (address1 === ethAddress) {
    if (allowance < liquidity) {
      let tx = await pair.approve(routerAddress, ethers.MaxUint256);
      await tx.wait();
    }
    await RouterChain.removeLiquidityETHSupportingFeeOnTransferTokens(
      address2,
      liquidity,
      amount2Min,
      amount1Min,
      deadline
    );
  }
}

export async function getStats(
  address1,
  signer,
  chain
) {
  try { console.log('[getStats] start', { chain, address1 }); } catch (_) {}
  let RouterChain = EthRouterSwap
  let contractChain = EthcontractUni
  try {
    let decimals;
    decimals = 18
    const address2 = await RouterChain.WETH();
    try { console.log('[getStats] WETH/WSOL', address2); } catch (_) {}
    const pairAddress = await contractChain.getPair(address1, address2);
    try { console.log('[getStats] pairAddress', pairAddress); } catch (_) {}
    const pairContract = new Contract(pairAddress, PAIR.abi, signer.provider);
    const usdcToEthRaw = await RouterChain.usdcToEth(1n);
    let eth_price = (Number(usdcToEthRaw))/Number((10 ** decimals));
    try { console.log('[getStats] usdcToEthRaw', usdcToEthRaw?.toString?.() ?? usdcToEthRaw, 'eth_price', eth_price); } catch (_) {}
    if (pairAddress !== "0x0000000000000000000000000000000000000000") {
      let usrShare;
      usrShare = (await pairContract.viewShare()).toString()
      let total = (await pairContract.totalCollected()).toString();
      let pool = (await pairContract.poolBalance()).toString();
      try { console.log('[getStats] raw', { usrShare, total, pool, decimals }); } catch (_) {}
      let share = (
        (Number(ethers.formatUnits(usrShare, decimals)) * 1) /
        eth_price
      ).toFixed(2);
      let totalCollected = (
        (Number(ethers.formatUnits(total, decimals)) * 1) /
        eth_price
      ).toFixed(2);
      let poolBalance = (
        (Number(ethers.formatUnits(pool, decimals)) * 1) /
        eth_price
      ).toFixed(2);
      try { console.log('[getStats] formatted USD', { share, totalCollected, poolBalance }); } catch (_) {}
      //let lockTime = Number(ethers.utils.formatEther(await pairContract.lockTime()));

      return [
        share.toString(),
        totalCollected.toString(),
        poolBalance.toString(),
      ];
    } else {
      //console.log("no rewards yet");
      try { console.warn('[getStats] zero pair address'); } catch (_) {}
      return [0, 0, 0];
    }
  } catch (err) {
    try { console.error('[getStats] error', err); } catch (_) {}
    return [0, 0, 0];
  }
}
export async function claimRewards(
  address1,
  signer,
  chain
) {
  let RouterChain = EthRouterSwap;
  let contractChain = EthcontractUni;
  const address2 = await RouterChain.WETH();
  const pairAddress = await contractChain.getPair(address1, address2);
  let pairContract;
  pairContract = new Contract(pairAddress, PAIR.abi, signer);
  if (pairAddress !== "0x0000000000000000000000000000000000000000") {
    await pairContract.claimShare();
  }
}

//==========  STAKE VISTA FUNCTIONS (ETH ONLY) =================

export async function stake (
  amount,
  signer
) {
  const routerContract = new ethers.Contract("0xCEDd366065A146a039B92Db35756ecD7688FCC77", ROUTER.abi,signer);

  const network = await signer.provider.getNetwork();
  const chainId = Number(network.chainId);
  if (chainId == 1) {
    let accountAddress = await signer.getAddress();
    const stakeAddress = "0xEE5a6F8a55B02689138c195031d09BAFDc7d278F";
    const VISTA = "0xC9bCa88B04581699fAb5aa276CCafF7Df957cbbf";
    const token = new Contract(VISTA, ERC20.abi, signer);
    const allowance1 = await token.allowance(
      accountAddress,
      routerContract.getAddress()
    );

    if (Number(allowance1) < amount*(10**18)) {
      let tx = await token.approve(
        routerContract.getAddress(),
        ethers.MaxUint256
      );
      await tx.wait();
    }

    await routerContract.hardstake(stakeAddress, VISTA, BigInt(amount*(10**18)));
  } else {
    //console.log("Can only stake VISTA in the ETH network")
  }
}

export async function unstake (
  amount,
  signer,
) {
  const network = await signer.provider.getNetwork();
  const chainId = Number(network.chainId);
  if (chainId == 1) {
    const stakeAddress = "0xEE5a6F8a55B02689138c195031d09BAFDc7d278F";
    const stakeContract = new Contract(stakeAddress, HARDSTAKE.abi, signer);
    await stakeContract.withdraw(BigInt(amount*(10**18)));
  } else {
    //console.log("Can only stake VISTA in the ETH network")
  }
}

export async function claimRewardsSTAKE(
  signer,
) {
  const network = await signer.provider.getNetwork();
  const chainId = Number(network.chainId);
  if (chainId == 1) {
  const stakeAddress = "0xEE5a6F8a55B02689138c195031d09BAFDc7d278F";
  const stakeContract = new Contract(stakeAddress, HARDSTAKE.abi, signer);
  await stakeContract.claimShare();
  } else {
    //console.log("Can only stake VISTA in the ETH network")
  }
}

function convertUnixToTimeString(unixTimestamp) {
  let seconds = unixTimestamp;

  // Calculate hours
  const hours = Math.floor(seconds / 3600); // Get full hours
  seconds %= 3600; // Remainder for minutes

  // Calculate minutes
  const minutes = Math.floor(seconds / 60); // Get full minutes
  if(unixTimestamp ===0 || unixTimestamp ===null || unixTimestamp ===''){
    return `0`
  }
  return `Hours: ${hours}, Minutes: ${minutes}`;
}

export async function getStatsSTAKE(
  signer
) {
  try {
    const routerContract = new ethers.Contract("0xCEDd366065A146a039B92Db35756ecD7688FCC77", ROUTER.abi,signer);

    const stakeAddress = "0xEE5a6F8a55B02689138c195031d09BAFDc7d278F";
    const stakeContract = new Contract(stakeAddress, HARDSTAKE.abi, signer);
    const eth_price = (Number(await routerContract.usdcToEth(1)))/Number((10 ** 18));
    
      let usrShare = (await stakeContract.viewShare()).toString();
      let total = (await stakeContract.totalCollected()).toString();
      let pool = (await stakeContract.poolBalance()).toString();
      //console.log(usrShare,total,pool)
      let share = (
        (Number(ethers.formatEther(usrShare)) * 1) /
        eth_price
      ).toFixed(2);
      let totalCollected = (
        (Number(ethers.formatEther(total)) * 1) /
        eth_price
      ).toFixed(2);
      let poolBalance = (
        (Number(ethers.formatEther(pool)) * 1) /
        eth_price
      ).toFixed(2);

      let yearlyRevenue = await getYearlyRevenue(totalCollected, "0xC9bCa88B04581699fAb5aa276CCafF7Df957cbbf", "ethereum")

      return [
        share.toString(),
        yearlyRevenue.toString(),
        poolBalance.toString(),
      ];
  } catch (err) {
    console.log(err)
    return [0, 0, 0];
  }
}

export async function getStakerInfoSTAKE(signer) {
  const staker = await signer.getAddress();
  const stakeAddress = "0xEE5a6F8a55B02689138c195031d09BAFDc7d278F";
  const stakeContract = new Contract(stakeAddress, HARDSTAKE.abi, signer);

  let [amountStaked, timeLeftToUnlock, currentShare] = await stakeContract.getStakerInfo(staker);

  const amount = Number(ethers.formatUnits(amountStaked, 18));
  let timeLeftFormatted = convertUnixToTimeString(Number(timeLeftToUnlock)).toString();
  return { amount, timeLeftFormatted, currentShare };
}

//================ HARDLOCK LP (ETH-onLY) ====================== //SOLANA FIX also fix decimals
export async function lpvistalock (
  amount,
  signer
) {
  const routerContract = new ethers.Contract("0xCEDd366065A146a039B92Db35756ecD7688FCC77", ROUTER.abi,signer);

  const network = await signer.provider.getNetwork();
  const chainId = Number(network.chainId);
  if (chainId == 1) {
    let accountAddress = await signer.getAddress();
    const lockAddress = "0x9099EF7f34dC1af0d27e49Dc5B604bcCC03dCB21";
    const VISTA_LP = "0xfdd05552F1377aA488AFed744c8024358AF02041";
    const token = new Contract(VISTA_LP, ERC20.abi, signer);
    const allowance1 = await token.allowance(
      accountAddress,
      routerContract.getAddress()
    );

    if (Number(allowance1) < amount*(10**18)) {
      let tx = await token.approve(
        routerContract.address,
        ethers.MaxUint256
      );
      await tx.wait();
    }
    await routerContract.hardstake(lockAddress, VISTA_LP, BigInt(amount*(10**18)));
  } else {
    //console.log("Can only stake VISTA-LP in the ETH network")
  }
}

export async function lpvistaunlock (
  amount,
  signer,
) {
  const network = await signer.provider.getNetwork();
  const chainId = Number(network.chainId);
  if (chainId == 1) {
    const lockAddress = "0x9099EF7f34dC1af0d27e49Dc5B604bcCC03dCB21";
    const lockContract = new Contract(lockAddress, HARDSTAKE.abi, signer);
    await lockContract.withdraw(BigInt(amount*(10**18)));
  } else {
    //console.log("Can only stake VISTA-LP in the ETH network")
  }
}

export async function lpvistastaker(signer) {
  const staker = await signer.getAddress();

  const lockAddress = "0x9099EF7f34dC1af0d27e49Dc5B604bcCC03dCB21";
  const lockContract = new Contract(lockAddress, HARDSTAKE.abi, signer);

  let [amountStaked, timeLeftToUnlock, currentShare] = await lockContract.getStakerInfo(staker);

  const amount = Number(ethers.formatUnits(amountStaked, 18));
  let timeLeftFormatted = convertUnixToTimeString(Number(timeLeftToUnlock)).toString();

  return { amount, timeLeftFormatted, currentShare };
}

//===================== ALL CHAINS =========================

export async function lock (
  address1,
  amount,
  signer,
  tokenAddress,
  chain
) {
  const network = await signer.provider.getNetwork();
  const chainId = Number(network.chainId);
  const RouterChain = new ethers.Contract(
    "0xCEDd366065A146a039B92Db35756ecD7688FCC77",
    ROUTER.abi,
    signer
  );  
  if(chainId !== 1){
    throw Error("Please Switch to ETH chain")
    return;
  }    

  let lockerAddress = "0xF6B510928ab880507246CD6946b7F061Eb8A9C78";
  console.log("CHAIN ID", chainId)
  console.log("LOCKER ADDRESS", lockerAddress)

  let accountAddress = await signer.getAddress();
  //const tokenAccount = new Contract(tokenAddress, ERC20.abi,signer)
  //const decimals = await getDecimals(tokenAccount)
  const token = new Contract(address1, ERC20.abi, signer);
  const allowance1 = await token.allowance(
    accountAddress,
    await RouterChain.getAddress()
  );

  const needed = ethers.parseUnits(String(amount), 18);
  if (allowance1 < needed) {
    let tx = await token.approve(
      await RouterChain.getAddress(),
      ethers.MaxUint256
    );
    await tx.wait();
  }
  await RouterChain.hardstake(lockerAddress, address1, needed);

  
}

export async function claimRewardsLOCK(
  address1,
  signer,
) {
  const network = await signer.provider.getNetwork();
  const chainId = Number(network.chainId);
  if (chainId !== 1) {
    throw Error("Please Switch to ETH chain")
  }
  let lockerAddress = address1 === "0xfdd05552F1377aA488AFed744c8024358AF02041"
    ? "0x9099EF7f34dC1af0d27e49Dc5B604bcCC03dCB21"
    : "0xF6B510928ab880507246CD6946b7F061Eb8A9C78";
  if (lockerAddress == "0x9099EF7f34dC1af0d27e49Dc5B604bcCC03dCB21") {
    const lockerContract = new Contract(lockerAddress, HARDLOCK_VISTA.abi, signer);
    await lockerContract.claimShare();
  } else {
    const lockerContract = new Contract(lockerAddress, HARDLOCK.abi, signer);
    await lockerContract.claimShare(address1);
  }
}

export async function getStatsLOCK(
  address1,
  signer,
  chain
) {
  try {
    let RouterChain = new ethers.Contract(
      "0xCEDd366065A146a039B92Db35756ecD7688FCC77",
      ROUTER.abi,
      signer
    );      
    const network = await signer.provider.getNetwork();
    const chainId = Number(network.chainId);
    if (chainId !== 1) {
      throw new Error("Please connect your wallet to the selected network!")
    }
    let lockerAddress;
    if(address1 == "0xfdd05552F1377aA488AFed744c8024358AF02041") {
      lockerAddress = "0x9099EF7f34dC1af0d27e49Dc5B604bcCC03dCB21";
    } else {
      lockerAddress = "0xF6B510928ab880507246CD6946b7F061Eb8A9C78";
    }
    let lockerContract;
    if (lockerAddress == "0x9099EF7f34dC1af0d27e49Dc5B604bcCC03dCB21") {
      lockerContract = new Contract(lockerAddress, HARDLOCK_VISTA.abi, signer);
    } else {
      lockerContract = new Contract(lockerAddress, HARDLOCK.abi, signer);
    }

    let decimals;
    decimals = 18

    const eth_price = (Number(await RouterChain.usdcToEth(1)))/Number((10 ** decimals));
      let usrShare;
      if (lockerAddress == "0x9099EF7f34dC1af0d27e49Dc5B604bcCC03dCB21") {
        usrShare = (await lockerContract.viewShare()).toString();
      } else {
        usrShare = (await lockerContract.viewShare(address1)).toString();
      }
      let total = (await lockerContract.totalCollected()).toString();
      let share = (
        (Number(ethers.formatUnits(usrShare, decimals)) * 1) /
        eth_price
      ).toFixed(2);
      let totalCollected = (
        (Number(ethers.formatUnits(total, decimals)) * 1) /
        eth_price
      ).toFixed(2);
      let poolBalance = 0;
      if (lockerAddress == "0x9099EF7f34dC1af0d27e49Dc5B604bcCC03dCB21") {
        totalCollected = await getYearlyRevenue(Number(totalCollected), "0xC9bCa88B04581699fAb5aa276CCafF7Df957cbbf", "ethereum")
        poolBalance = (
          (Number(ethers.formatUnits(await lockerContract.poolBalance(), decimals)) * 1) /
          eth_price
        ).toFixed(2);
      }
      if (lockerAddress == "0x9099EF7f34dC1af0d27e49Dc5B604bcCC03dCB21"){
        return [
          share.toString(),
          totalCollected.toString(),
          poolBalance.toString(),
        ];
      } else {
        return [
          share.toString(),
          totalCollected.toString(),
          totalCollected.toString(),
        ]
      }
  } catch (err) {
    //console.log(err)
    return [0, 0, 0];
  }
}

// Removed non-ETH helper

//================== Launch ====================

//NEON: launch, removeLiquidity, deployLiquidity, claimRewards

export async function launch(
  address1,
  address2,
  amount1,
  amount2,
  amount1min,
  amount2min,
  signer,
  buyLpFee,
  sellLpFee,
  buyCreatorFee,
  sellCreatorFee,
  protocolAddress,
  chain
) {
    let RouterChain = EthRouterSwap.connect(signer);
  let account = await signer.getAddress();
  let routerAddress = await RouterChain.getAddress();
  
  let token1;
  let token2;
  token1 = new Contract(address1, ERC20.abi, signer);
  token2 = new Contract(address2, ERC20.abi, signer);

  const token1Decimals = await getDecimals(token1);
  const token2Decimals = await getDecimals(token2);

  const amountIn1 = ethers.parseUnits(amount1, token1Decimals);
  const amountIn2 = ethers.parseUnits(amount2, token2Decimals);
  const amount1Min = ethers.parseUnits(amount1min, token1Decimals);
  const amount2Min = ethers.parseUnits(amount2min, token2Decimals);

  const wethAddress = await RouterChain.WETH();

  if (address1 === wethAddress) {
    const allowance2 = await token2.allowance(account, routerAddress);
    if (allowance2 < amountIn2) {
      let tx = await token2.approve(routerAddress, ethers.MaxUint256);
      await tx.wait();
    }

    await RouterChain.launch(
      address2,
      amountIn2,
      amount2Min,
      amount1Min,
      buyLpFee,
      sellLpFee,
      buyCreatorFee,
      sellCreatorFee,
      protocolAddress,
      { value: amountIn1 }
    );
  }
}

//================== Neon (removed) ======================

// Removed legacy Solana helper stubs and utilities

async function pairFor(tokenAddress, chain) {
  const weth = await EthRouterSwap.WETH();
  return await EthcontractUni.getPair(tokenAddress, weth);
}

async function getYearlyRevenue(amount, tokenAddress, chain) {
  let pairAddr = await pairFor(tokenAddress, chain)
  let blockTimeSeconds = 12;
  let provider = ethprovider;
  const pair = new ethers.Contract(pairAddr, PAIR.abi, provider);
  const latestBlock  = await provider.getBlockNumber();
  let creationBlock = 20649629/*await blockForTime(
    Number(await pair.creation_time()),
    provider, 
    latestBlock
  );
  */
  const existanceDays = Math.round(((latestBlock - creationBlock)*blockTimeSeconds)/86400);
  const yearlyRev = Math.round(365/existanceDays*(amount))
  return yearlyRev
}

export async function getRevenue(
  latestBlockFetched = null,
  totalSwaps = 0,
  pairAddress,
  chain
) {
  let provider = ethprovider;
  let blockTimeSeconds = 12;
  let step = 9000 // keep well under the 10 000-log limit
  //change by chain
  //const provider = ethprovider;

  /** event Swap(address,uint256,uint256,uint256,uint256,address) */
  const SWAP_TOPIC = ethers.id(
    "Swap(address,uint256,uint256,uint256,uint256,address)"
  );

  const pairAddr = pairAddress;
  const pair     = new ethers.Contract(pairAddr, PAIR.abi, provider);
  // Find an approximate creation block by scanning backwards for first Swap
  let creationBlock = await (async () => {
    const tip = await provider.getBlockNumber();
    const SWAP_TOPIC = ethers.id(
      "Swap(address,uint256,uint256,uint256,uint256,address)"
    );
    let low = 0;
    let high = tip;
    // binary search for first swap occurrence (approx)
    while (low < high) {
      const mid = Math.floor((low + high) / 2);
      const logs = await provider.getLogs({
        address: pairAddr,
        topics: [SWAP_TOPIC],
        fromBlock: mid,
        toBlock: mid + 5000 > tip ? tip : mid + 5000,
      });
      if (logs.length > 0) {
        high = mid;
      } else {
        low = mid + 5001;
      }
    }
    return Math.max(0, Math.min(low, tip));
  })();

  // ─── decide where to start ────────────────────────────────────────────────
  let from;
  if (latestBlockFetched === null) {
    // first run → start at the pair's first block
    from = creationBlock;
  } else {
    // resume → start *after* the block we already scanned
    from = latestBlockFetched + 1;
  }

  const tip  = await provider.getBlockNumber();

  // ─── main scan loop ───────────────────────────────────────────────────────
  while (from <= tip) {
    const to = Math.min(from + step, tip);
    try {
      const logs = await provider.getLogs({
        address:   pairAddr,
        topics:   [SWAP_TOPIC],
        fromBlock: from,
        toBlock:   to
      });
      totalSwaps += logs.length;
      from        = to + 1;    // next window
      //console.log('Currenttotal', totalSwaps)
    } catch (err) {
      // If we hit the 10 000-result ceiling, shrink the window and retry
      if (err.message?.match(/results.*10000/)) {
        step = Math.floor(step / 2);
        if (step === 0) throw Error("cannot shrink window any further");
      } else {
        throw err;             // network / RPC error etc.
      }
    }
  }

  // ─── done ────────────────────────────────────────────────────────────────
  //console.log("TOTAL SWAPS EVER", totalSwaps);

  const {yearlyRev, avgFee} = await getYearlyRevenue(creationBlock, tip, totalSwaps, pairAddr, provider, blockTimeSeconds)
  //console.log("TOTAL USD PER YEAR ", yearlyRev);
  return {
    latestBlockFetched: tip,   // new checkpoint
    totalSwaps, 
    yearlyRev,
    avgFee
  };
}

//Register User (WSOL)
//Summary: FOR every call that router transfer froms TOKEN from USER user must call INitDelegateAndApproveMAX
//Launch & AddLP will have to call INitDelegateAndApproveMAXWRAP for that token
//Launch must init wsol/token-owner=pairpK for both
//Remove LP, must approve router to use ERC20 lp tokens ensures ATAs are initialized to receive wsol/token

//swapETH only needs to wrapSOL, user registered good to go
//SwapTokens will have to make sure all is initiated for token if never done before

//init ATA for pair as well FOR BOTH mintPk = WSOL AND TOKEN